export const ROUTERS_PATH = {
    ROOT_PATH: "/",
    ERROR: "/error",
    LOGIN: "/login",
    STARTINGPAGE1: "/",
    CHOOSEEXERCISE: "/choose-exercise",
    CHOOSEEXERCISEWITHHISTORY: "/choose-exercise-with-history",
    CAPTUREEXERCISE: "/capture-exercise",
    SEARCHEXRCISE: "/search-exercise",
    DISPLAYEXERCISE: "/display-exercise",
    EXERCISEQUESTIONS: "/exercise-questions",
    CHAT: "/chat",    
    QUESTIONSTEPS: "/question-steps",
    PLAYGROUND: "/playground",    
    UPLOADCOMPLETE: "/upload-complete",
    DASHBOARD: "/dashboard",
    SEARCHBYBOOK: "/search-by-book",
    USERREGISTRATIONINITIAL: "/user-registration-initial",
    USERREGISTRATIONSTEP1: "/user-registration-step1",
    USERREGISTRATIONOTP: "/user-registration-otp",
    USERPROFILE: "/user-profile",
    RESETPASSWORD: "/reset-password",
    DISPLAYVIDEO: "/display-video",
    SELFTESTSTART: "/self-test-start",
    SELFTESTEXERCISES: "/self-test-exercises",
    SELFTESTSUMMARY: "/self-test-summary",
    SELFTESTANSWERPREVIEW: "/self-test-answer-preview",
    CHOOSEPACKAGES: "/choose-packages",
    PAYMENT: "/payment",    
    PAYMENTSTATUS: "/payment-status",
    LESSONSBUILDER: "/admin/lessons-builder",
    SHAREDLESSON: "/shared-lesson/:token",
    V2_ONBOARDING: "/onboarding",
    LEARNING: "/learning",
    USER_MAIN_DASHBOARD: "/user-main-dashboard",
    SEARCH_LESSON: "/search-lesson",
    PLAY_LESSON: "/play-lesson",
    LESSON_SUMMARY: "/lesson-summary",
    USER_ALL_MISSIONS: "/user-all-missions",
    EXERCISE_PRACTICE: "/exercise-practice",
    EXERCISES_HOMEWORK: "/exercises-homework",
    TEACHER_DASHBOARD: "/teacher-dashboard",
    TEACHER_TOPICS: "/teacher-dashboard/topics",
    TEACHER_PRACTICES: "/teacher-dashboard/practices",
    TEACHER_ACCOUNT: "/teacher-dashboard/account",
    NOTIFICATIONS: "/notifications",
  }